<template>
  <i :class="iconClass" :style="iconStyle" @click="handleClick"></i>
</template>

<script>
export default {
  name: 'BccIcon',
  props: {
    type: {
      type: String
    },
    size: {
      type: [String, Number]
    },
    color: {
      type: String
    }
  },
  computed: {
    iconClass () {
      return [
        'bcc-iconfont',
        {
          [`bcc-icon-${this.type}`]: !!this.type
        }
      ]
    },
    iconStyle () {
      let style = {}
      if (this.size) {
        if (typeof this.size === 'string') {
          style['font-size'] = this.size
        } else {
          style['font-size'] = `${this.size}px`
        }
      }
      if (this.color) {
        style['color'] = this.color
      }
      return style
    }
  },
  methods: {
    handleClick (event) {
      // 此处为了代理原生点击事件 故不使用on-click形式
      this.$emit('click', event)
    }
  }
}
</script>
